import {
  AddressCustomFieldValues,
  Client,
  Company,
} from 'src/store/clients/types';

export type CustomFieldValue =
  | string
  | string[]
  | boolean
  | AddressCustomFieldValues;

export type CompanyWithClients = Company & {
  clients: Client[];
};

export const isAddressCustomFieldValues = (
  customFieldValue: CustomFieldValue,
): customFieldValue is AddressCustomFieldValues =>
  (customFieldValue as AddressCustomFieldValues).fullAddress !== undefined;

export interface CustomFieldValueData {
  fieldId: string;
  value?: CustomFieldValue;
  updatingClient?: Client;
  updatingCompany?: Company;
}
